import { createSlice, PayloadAction, nanoid } from '@reduxjs/toolkit';
import { NotificationEvent } from '../types';

type StreamStatus = 'idle' | 'connecting' | 'connected' | 'error';

interface NotificationsState {
  events: NotificationEvent[];
  status: StreamStatus;
  lastHeartbeat?: string | null;
}

const initialState: NotificationsState = {
  events: [],
  status: 'idle',
  lastHeartbeat: null,
};

interface EnqueuePayload {
  event: Omit<NotificationEvent, 'id'> & { id?: string };
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    enqueueNotification(state, action: PayloadAction<EnqueuePayload>) {
      const { event } = action.payload;
      const id = event.id ?? nanoid();
      const entry: NotificationEvent = {
        ...event,
        id,
      };
      state.events.unshift(entry);
      state.events = state.events.slice(0, 20);
    },
    dismissNotification(state, action: PayloadAction<string>) {
      state.events = state.events.filter((item: NotificationEvent) => item.id !== action.payload);
    },
    setStreamStatus(state, action: PayloadAction<StreamStatus>) {
      state.status = action.payload;
    },
    updateHeartbeat(state, action: PayloadAction<string>) {
      state.lastHeartbeat = action.payload;
    },
    clearNotifications(state) {
      state.events = [];
    },
  },
});

export const {
  enqueueNotification,
  dismissNotification,
  setStreamStatus,
  updateHeartbeat,
  clearNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
